module.exports = __webpack_public_path__ + "android-icon-48x48.png?ffdb43d20721b79ad034be55799f3c00";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/android-icon-48x48.png
// module id = 124
// module chunks = 0